































































































































































































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { MobileCoupon, Coupon, Tenant } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef, DocData } from "@/stores";
import { createUser, updateUser, updatePassword } from "@/stores/userUtil";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import draggable from "vuedraggable";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import { default as loadImage, parseMetaData } from "blueimp-load-image";
import { v4 as Uuidv4 } from "uuid";
import dayjs from "dayjs";
import { ShopCategoryType } from "@/models/tenant";

const db = firebaseProject.firestore();
interface TenantData {
  tenantId: string;
  shopName?: string;
  shopCategoryType?: ShopCategoryType;
  check: boolean;
  maximumNumber?: number | null;
  mobileOrderEnabled?: boolean;
}
export default shopBase.extend(Vue).extend({
  name: "MobileOrderCouponDetail",
  mixins: [form, autoclose],
  components: { VueCtkDateTimePicker, draggable },
  data(): {
    authentication: object;
    transitionName: string;
    justifyNow: boolean;
    imageEditor: boolean;
    replaceIndex: number;
    editedImage: string[];
    items: any[];
    guide: string;
    notice: string;
    couponShop: boolean;
    shopCategoryType: ShopCategoryType | string | undefined;
    tenantDatas: TenantData[];
    tenantSelectedAll: boolean;
    discountAmount: number;
  } {
    return {
      authentication,
      transitionName: "",
      justifyNow: false,
      imageEditor: false,
      replaceIndex: -1,
      editedImage: [],
      items: [],
      guide: "",
      notice: "",
      couponShop: true,
      shopCategoryType: "0",
      tenantDatas: [],
      tenantSelectedAll: false,
      discountAmount: 5
    };
  },
  async created() {
    const docId = this.$route.params.id;
    if (docId) {
      const _doc = await this.document.ref?.get();
    }
    const tenantDocs = await db
      .collection("tenant")
      .where("shopId", "==", this.shopId)
      .get()
      .then(snapshot => {
        return snapshot.docs.map(doc => {
          return new DocDataRef({
            document: doc.data() as Tenant,
            id: doc.id,
            ref: doc.ref
          } as DocData<Tenant>);
        });
      });

    tenantDocs.map(doc => {
      const tenantSelectedDatas =
        this.document.effective.tenantSelectedDatas ?? [];
      const tenantSelectedData = tenantSelectedDatas.find(
        item => item.tenantId == doc.id
      );
      if (this.tenantStatus(doc) === 1) {
        this.tenantDatas.push({
          tenantId: doc.id,
          shopName: doc.document?.shopName,
          shopCategoryType: doc.document?.shopCategoryType,
          check: tenantSelectedData ? true : false,
          mobileOrderEnabled:
            doc.document?.deliveryEnabled || doc.document?.pickupEnabled
        });
      }
    });
    this.document.effective.couponType = this.document.effective.couponType
      ? this.document.effective.couponType
      : 1;
    this.discountAmount = this.document.effective.discountAmount
      ? this.document.effective.discountAmount
      : 5;
    const arr = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
    if (arr.indexOf(this.discountAmount) === -1) {
      this.discountAmount = 5;
    }
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    const duplicateFrom = this.$route.query.duplicateFrom;
    if (duplicateFrom != null) {
      console.log(`duplicate from: ${duplicateFrom}`);
      const snapshot = await db
        .collection("mobileCoupon")
        .doc(duplicateFrom as string)
        .get();
      if (snapshot) {
        this.document.effective.title = snapshot.data()?.title;
        this.document.effective.notice = snapshot.data()?.notice;
        this.document.effective.couponType = snapshot.data()?.couponType || 1;
        this.document.effective.discountAmount = snapshot.data()?.discountAmount;
        if (snapshot.data()?.totalAmountRestriction) {
          this.document.effective.totalAmountRestriction = snapshot.data()?.totalAmountRestriction;
        }
        this.document.effective.couponCode = snapshot.data()?.couponCode;
        this.document.effective.hidden = snapshot.data()?.hidden
          ? snapshot.data()?.hidden
          : false;
        this.document.effective.useLimitType = snapshot.data()?.useLimitType;
        if (snapshot.data()?.useLimit) {
          this.document.effective.useLimit = snapshot.data()?.useLimit;
        }
        this.document.effective.tenantSelectedType = snapshot.data()?.tenantSelectedType;
        if (this.document.effective.tenantSelectedType) {
          this.document.effective.tenantSelectedDatas = snapshot.data()?.tenantSelectedDatas;
        } else {
          this.document.effective.tenantSelectedType = 0;
        }
        if (snapshot.data()?.totalAmountMaxRestriction) {
          this.document.effective.totalAmountMaxRestriction = snapshot.data()?.totalAmountMaxRestriction;
        }

        if (snapshot.data()?.availableFrom) {
          this.document.effective.availableFrom =
            snapshot.data()?.availableFrom &&
            dayjs(snapshot.data()?.availableFrom).format();
        }
        if (snapshot.data()?.availableTo) {
          this.document.effective.availableTo =
            snapshot.data()?.availableTo &&
            dayjs(snapshot.data()?.availableTo).format();
        }
      }
    }
  },
  computed: {
    collection(): Collection<MobileCoupon> {
      return new Collection(
        db.collection("mobileCoupon") as firestore.CollectionReference<
          MobileCoupon
        >
      );
    },
    document(): Document<MobileCoupon> {
      const id = this.$route.params.id;
      return this.collection.doc(id, { noListen: true });
    },
    basepath(): string {
      return "shop/" + this.shopId + "/";
    },
    pageTitle(): string {
      const id = this.$route.params.id;
      return id
        ? "モバイルオーダークーポン詳細"
        : "モバイルオーダークーポン新規登録";
    },
    pageHeader(): string {
      const id = this.$route.params.id;
      return id ? "詳細" : "新規モバイルオーダークーポン";
    },
    filterTenantDataByCategory(): TenantData[] | undefined {
      const data =
        this.tenantDatas.filter(data => {
          return (
            (this.shopCategoryType == "0" ||
              data.shopCategoryType == this.shopCategoryType) &&
            data.mobileOrderEnabled
          );
        }) || [];
      return data.sort((a, b) => {
        if (a.shopName !== undefined && b.shopName !== undefined) {
          return a.shopName?.localeCompare(b.shopName, "ja");
        }
        return 0;
      });
    },
    filterTenantDataByCheck(): TenantData[] | undefined {
      const data =
        this.tenantDatas.filter(data => {
          return data.check;
        }) || [];
      return data.sort((a, b) => {
        if (a.shopName !== undefined && b.shopName !== undefined) {
          return a.shopName?.localeCompare(b.shopName, "ja");
        }
        return 0;
      });
    }
  },
  methods: {
    async validateCouponCode() {
      const couponCode = String(this.document.effective.couponCode);
      if (!couponCode || couponCode.length == 0) return true;
      const documentId = this.$route.params.id;
      const checkSnapshot = await db
        .collection("mobileCoupon")
        .where("couponCode", "==", couponCode)
        .where("shopId", "==", this.shopId)
        .get();
      const otherDocs = checkSnapshot.docs.filter(function(
        coupon,
        index,
        array
      ) {
        return documentId != coupon.id;
      });
      return otherDocs.length == 0;
    },
    async preSave() {
      this.document.effective.publishStatus = 2;
      this.document.effective.tenantId = null;
      this.document.effective.tenantSelectedDatas = [];
      if (this.document.effective.couponType == 1)
        this.document.effective.discountAmount = this.discountAmount;
      for (const tenantData of this.tenantDatas) {
        if (tenantData.check && tenantData.mobileOrderEnabled) {
          this.document.effective.tenantSelectedDatas.push({
            tenantId: tenantData.tenantId
          });
        }
      }
      const validCode = await this.validateCouponCode();
      if (!validCode) {
        alert({
          title: "エラー",
          text: "クーポンコードが重複しています。"
        });
        return false;
      }
      if (
        this.document.effective.shopId &&
        this.document.effective.shopId != this.shopId
      ) {
        alert({
          title: "エラー",
          text: "操作対象SCが異なるため、保存できません。"
        });
        return false;
      }
      if (this.document.effective.tenantSelectedType) {
        if (
          !this.document.effective.tenantSelectedDatas ||
          this.document.effective.tenantSelectedDatas?.length == 0
        ) {
          alert({
            title: "エラー",
            text: "割引適用店舗を選択してください。"
          });
          return false;
        }
      }
      const totalAmountRestriction = this.document.effective
        .totalAmountRestriction
        ? this.document.effective.totalAmountRestriction
        : -1;
      const discountAmount = this.document.effective.discountAmount
        ? this.document.effective.discountAmount
        : 0;
      const totalAmountMaxRestriction = this.document.effective
        .totalAmountMaxRestriction
        ? this.document.effective.totalAmountMaxRestriction
        : -1;
      if (
        totalAmountRestriction > 0 &&
        Math.round(totalAmountRestriction) <= discountAmount &&
        this.document.effective.couponType == 2
      ) {
        alert({
          title: "エラー",
          text:
            "割引適用最低額条件（一会計/税込） は 値引き金額（税込） より大きくなければなりません"
        });
        return false;
      }
      if (discountAmount < 1 && this.document.effective.couponType == 2) {
        alert({
          title: "エラー",
          text: "値引き金額（税込） は 1 より大きくなければなりません"
        });
        return false;
      }
      if (totalAmountMaxRestriction < 1 && totalAmountMaxRestriction != -1) {
        alert({
          title: "エラー",
          text: "上限購入額（税込） は 1 より大きくなければなりません"
        });
        return false;
      }
      return true;
    },
    async register() {
      const status = await this.preSave();
      if (!status) return;
      if (this.document.canSave) {
        this.document.effective.shopId = this.shopId;
        const result = await this.document.save().catch(e => {
          console.log(e);
          alert({
            title: "エラー",
            text: "クーポンの保存に失敗しました。"
          });
        });
        if (result) {
          this.$router.push("/mobileorder/coupon");
        }
      } else {
        this.$router.push("/mobileorder/coupon");
      }
    },
    async registerAndPublish() {
      await this.register();
    },
    changeShopCategoryType() {
      this.tenantSelectedAll = false;
    },
    changeTenantSelectedAll() {
      for (const key in this.tenantDatas) {
        const tenantData = this.tenantDatas[key];
        if (
          (this.shopCategoryType == "0" ||
            tenantData.shopCategoryType == this.shopCategoryType) &&
          tenantData.mobileOrderEnabled
        ) {
          this.tenantDatas[key].check = this.tenantSelectedAll;
        }
      }
    },
    async deleteDocument() {
      const result = await this.document.remove();
      if (result && result.successed) {
        this.$router.push("/mobileorder/coupon");
      } else {
        alert({
          title: "エラー",
          text: "削除できませんでした。"
        });
      }
    },
    async saveAndDuplicate() {
      const status = await this.preSave();
      if (!status) return;
      if (this.document.canSave) {
        this.document.effective.shopId = this.shopId;
        const result = await this.document
          .save()
          .catch(e => {
            console.log(e);
            alert({
              title: "エラー",
              text: "クーポンの保存に失敗しました。"
            });
          })
          .then(() => {
            this.$router.push(
              "/mobileorder/coupon/item?duplicateFrom=" + this.document.id
            );
          });
      }
    }
  }
});
